
































































import VueBase from '@/pages/vue-base'
import Recruit, {IRecruit} from '@/models/Recruit'
import axios from 'axios'
import {apiV1AdminRecruitsPath} from '@/rails/routes'
import {Component, Emit, Prop} from 'vue-property-decorator'
import Recommend from '@/models/Recommend'
import MediaSelector from '@/components/admin/MediaSelector.vue'
import {Medium} from '@/models/Medium'

@Component({
  components: {
    MediaSelector
  }
})
export default class RecommendForm extends VueBase {
  @Prop(Object) readonly value!: Recommend

  @Emit('input')
  input(value: Recommend): Recommend {
    return value
  }

  @Emit()
  onSave(): Recommend {
    return this.value
  }

  recruits: Array<Recruit> = []
  active_statuses = [
    { text: '表示', value: true },
    { text: '非表示', value: false }
  ]
  showedRecommendRecruits = false
  showedMediaSelector = false
  headers = [
    { text: '', value: 'actions', sortable: false, width: 70 },
    { text: 'タイトル', value: 'title', width: 500 },
    { text: '契約形態', value: 'planString', width: 220 },
  ]
  keyword = ''
  selected = []
  filterMode: 'all' | 'excluded_basic' = 'excluded_basic'

  get internalValue(): Recommend {
    return this.value
  }

  set internalValue(val: Recommend) {
    this.input(val)
  }

  async mounted(): Promise<void> {
    await this.reload()
  }

  async reload(): Promise<void> {
    try {
      this.loading = true
      const recruits = await axios.get<Array<IRecruit>>(apiV1AdminRecruitsPath())
      this.recruits = recruits.data.map(r => new Recruit(r))
      this.loading = false
    } catch (e) {
      console.error(e)
    }
  }

  selectRecommendRecruits(): void {
    this.internalValue.recruits = this.selected
    this.showedRecommendRecruits = false
  }

  get viewRecruits(): Array<Recruit> {
    switch (this.filterMode) {
      case 'excluded_basic': return this.filtered.filter(recruit => recruit.plan === 'pro')
    }
    return this.filtered
  }

  get filtered(): Array<Recruit> {
    if (this.keyword) {
      return this.recruits.filter(
        recruit => recruit.title.toLocaleLowerCase().includes(this.keyword.toLocaleLowerCase())
      )
    }
    return this.recruits
  }

  onSelectMedium(medium: Medium): void {
    this.value.medium = medium
    this.showedMediaSelector = false
  }
}
